<template>
  <div v-if="!$root.reload" id="app">
    <home :page-suffix="pageSuffix"></home>
  </div>
</template>

<script>
export default {
  components: {
    home: () => import(/* webpackChunkName: "national" */ "./views/Home.vue")
  },
  provide() {
    return {
      $app: this
    };
  },
  data() {
    return {
      pageSuffix: "else"
    };
  },
  created() {
    let htmlName = window.location.pathname;
    let route = ["_project", "_product", ""];
    let pageSuffix = "else";
    if (dsf.url.isHistoryRoute()) {
      let base = dsf.url.getRouterBase();
      for (let i = 0; i < route.length; i++) {
        if (base.endsWith("/index/")) {
          pageSuffix = "index";
          break;
        } else if (base.endsWith("/index1/")) {
          pageSuffix = "index1";
          break;
        } else if (base.endsWith("/multiPage/")) {
          pageSuffix = "multiPage";
          break;
        } else {
          pageSuffix = "else";
        }
      }
    } else {
      for (let i = 0; i < route.length; i++) {
        if (htmlName.indexOf(`/index${route[i]}.html`) >= 0) {
          pageSuffix = "index";
          break;
        } else if (htmlName.indexOf(`/index1${route[i]}.html`) >= 0) {
          pageSuffix = "index1";
          break;
        } else {
          pageSuffix = "else";
        }
      }
    }

    this.pageSuffix = pageSuffix;
  },
  mounted() {},
  methods: {
  }
};
</script>